// components/AuthForm.tsx
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import "./authForm.css";

const schema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
});

type FormData = z.infer<typeof schema>;

interface AuthFormProps {
  type: 'login' | 'register';
  onSubmit: (email: string, password: string) => Promise<void>;
}

export default function AuthForm({ type, onSubmit }: AuthFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const [firebaseError, setFirebaseError] = useState<string>('');

  const submit = async (data: FormData) => {
    try {
      setFirebaseError('');
      await onSubmit(data.email, data.password);
    } catch (err: any) {
      setFirebaseError(err.message || 'Authentication failed');
    }
  };

  return (
    <div className='authform'>
    <form onSubmit={handleSubmit(submit)} className="space-y-4 max-w-md mx-auto mt-8rem">
      <h2 className="text-2xl font-semibold">{type === 'login' ? 'Login' : 'Register'}</h2>

      <input
        type="email"
        placeholder="Email"
        {...register('email')}
        className="w-full border rounded p-2"
      />
      {errors.email && <p className="text-red-500">{errors.email.message}</p>}

      <input
        type="password"
        placeholder="Password"
        {...register('password')}
        className="w-full border rounded p-2"
      />
      {errors.password && <p className="text-red-500">{errors.password.message}</p>}

      {firebaseError && <p className="text-red-500">{firebaseError}</p>}

      <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded">
        {type === 'login' ? 'Login' : 'Register'}
      </button>
    </form>
    </div>
  );
}
